module.exports = __webpack_public_path__ + "static/media/Faith_Single.136e54cc.jpg";